import { doc } from 'firebase/firestore'
import { Activity } from '../../../pure-js/types/GrooverTypes'
import { useFirestoreQuery } from './useFirestoreQuery'
import { db } from '../libs/Firebase'
import { Collections } from '../../../pure-js/libs/Collections'
import { createUniqueId } from '../../../pure-js/libs/Common'

export const useActivity = (id: string, force?: boolean, enrollmentId?: string) => {
  // Use a placeholder when id is empty to keep the Firestore doc reference valid
  // (Firebase requires an even number of path segments; 'activities/' alone is invalid).
  // The query is disabled via `enabled: !!id` so no fetch ever happens for the placeholder.
  const activity = useFirestoreQuery<Activity>(doc(db, `${Collections.ACTIVITIES}/${id || createUniqueId()}`), {
    fnName: 'useActivity',
    enabled: !!id
  })

  // Removed redirect logic for subevents - now returns the actual requested activity
  // Previously: subevents were redirected to parent events
  // Now: subevents are displayed directly without redirection

  // Return the initial activity (no redirection)
  return activity
}
